/**
 * @generated SignedSource<<4149bfb82b1d4049de7b7b5f7a6b6dbd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationBokaklippEditUpdateMutation$variables = {
  token: string;
};
export type IntegrationBokaklippEditUpdateMutation$data = {
  readonly store: {
    readonly activateIntegrationBokaklipp: {
      readonly id: string;
    } | null;
  };
};
export type IntegrationBokaklippEditUpdateMutation = {
  response: IntegrationBokaklippEditUpdateMutation$data;
  variables: IntegrationBokaklippEditUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "token"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "token",
            "variableName": "token"
          }
        ],
        "concreteType": "IntegrationBokaklipp",
        "kind": "LinkedField",
        "name": "activateIntegrationBokaklipp",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationBokaklippEditUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationBokaklippEditUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1aa2aaa84757c3347c2c9af1352ee781",
    "id": null,
    "metadata": {},
    "name": "IntegrationBokaklippEditUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationBokaklippEditUpdateMutation(\n  $token: String!\n) {\n  store {\n    activateIntegrationBokaklipp(token: $token) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "41c276a8205324910e3710434ef4d521";

export default node;
